import LandingPage from './LandingPage.js';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/LandingPage/index.js